import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import './styles/UserPopup.css'
// import "./Dev_Extreme.css";
import App from "./App";
import AuthProvider from "./context/AuthContext";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { Provider } from "react-redux";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
